module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "新增系统用户",
      "center": true,
      "visible": _vm.addVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "add-body"
  }, [_c('el-form', {
    ref: "submitForm",
    staticClass: "add-body-form",
    attrs: {
      "model": _vm.submitData,
      "rules": _vm.validatorRules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "add-body-div"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-用户名"
    },
    model: {
      value: (_vm.submitData.userName),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "userName", $$v)
      },
      expression: "submitData.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户编号",
      "prop": "userNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-用户编号"
    },
    model: {
      value: (_vm.submitData.userNumber),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "userNumber", $$v)
      },
      expression: "submitData.userNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号码",
      "prop": "phoneNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-手机号码"
    },
    model: {
      value: (_vm.submitData.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "phoneNumber", $$v)
      },
      expression: "submitData.phoneNumber"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "add-body-div"
  }, [_c('div', {
    staticClass: "add-body-div"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写"
    },
    model: {
      value: (_vm.submitData.password),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "password", $$v)
      },
      expression: "submitData.password"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "真实姓名",
      "prop": "realName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-真实姓名"
    },
    model: {
      value: (_vm.submitData.realName),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "realName", $$v)
      },
      expression: "submitData.realName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "gender"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": true,
      "placeholder": "请选择性别"
    },
    on: {
      "change": _vm.handleGendersChange
    },
    model: {
      value: (_vm.submitData.gender),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "gender", $$v)
      },
      expression: "submitData.gender"
    }
  }, _vm._l((_vm.authUserGenderOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "add-body-div"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户状态",
      "prop": "authStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": true,
      "placeholder": "请选择用户状态"
    },
    on: {
      "change": _vm.handleAuthStatusChange
    },
    model: {
      value: (_vm.submitData.authStatus),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "authStatus", $$v)
      },
      expression: "submitData.authStatus"
    }
  }, _vm._l((_vm.authStatusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称",
      "prop": "nickName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-昵称"
    },
    model: {
      value: (_vm.submitData.nickName),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "nickName", $$v)
      },
      expression: "submitData.nickName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属角色",
      "prop": "authStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": true,
      "multiple": "",
      "placeholder": "请选择所属角色"
    },
    on: {
      "change": _vm.handleAuthRoleChange
    },
    model: {
      value: (_vm.submitData.authRoleIdList),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "authRoleIdList", $$v)
      },
      expression: "submitData.authRoleIdList"
    }
  }, _vm._l((_vm.allRoleOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "center"
    }
  }, [_vm._v("上传头像")]), _vm._v(" "), _c('div', {
    staticClass: "add-body-div"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户头像图:"
    }
  }, [_c('div', {
    staticClass: "upload-item-view"
  }, [_c('UploadImg', {
    ref: "uploadAvatarUrl",
    staticClass: "upload-item",
    attrs: {
      "uploadApi": _vm.uploadUrl,
      "fileList": _vm.submitData.avatarUrlList,
      "limit": 1,
      "headers": _vm.uploadHeaders
    },
    on: {
      "subBack": _vm.uploadAvatarImageSuccess,
      "handleFileDelete": _vm.uploadAvatarImageDelete
    }
  })], 1)])], 1)])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提 交")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fc797446", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc797446"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/platform/auth-user/ItemAdd.vue
// module id = 1327
// module chunks = 1